import { createIcon } from '../createIcon';

export const PlaceOfWorshipIconConfig = {
  name: 'PlaceOfWorshipIcon',
  height: 512,
  width: 640,
  svgPath: 'M620.61 366.55L512 320v192h112c8.84 0 16-7.16 16-16V395.96a32 32 0 0 0-19.39-29.41zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.55A32 32 0 0 0 0 395.96zm464.46-149.28L416 217.6V102.63c0-8.49-3.37-16.62-9.38-22.63L331.31 4.69c-6.25-6.25-16.38-6.25-22.62 0L233.38 80c-6 6-9.38 14.14-9.38 22.63V217.6l-48.46 29.08A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.66-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const PlaceOfWorshipIcon = createIcon(PlaceOfWorshipIconConfig);

export default PlaceOfWorshipIcon;